// Package imports
import { use100vh } from 'react-div-100vh';

type Props = {
  children: React.ReactNode;
  className?: string;
};

const Height100Div = ({ children, className }: Props) => {
  const height = use100vh();
  const halfHeight = height ? height - 88 : '100vh';
  return (
    <div style={{ height: halfHeight }} className={className ? className : ''}>
      {children}
    </div>
  );
};

export default Height100Div;
